<h2 class="mb-2 text-lg font-medium text-heading">{{ label }}</h2>
<ul class="max-w-md space-y-1 text-body list-disc list-inside text-md">
  @for (item of items; track $index) {
    <li>{{ item }}</li>
  } @empty {}

</ul>
